var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-9 7a9 9 0 1 1 18 0 9 9 0 0 1-18 0m8.329 4.973a1 1 0 0 1-.788-1.174l.744-3.779h-.279a1 1 0 0 1 0-2h1.495a1 1 0 0 1 .98 1.193l-.978 4.972a1 1 0 0 1-1.174.788m1.374-10.551a1.285 1.285 0 1 0 0 2.57 1.285 1.285 0 0 0 0-2.57",
  clipRule: "evenodd"
})));
export default SvgInfo;